import { Component, Host, h, Prop, Watch } from '@stencil/core';
export class Avatar {
  constructor() {
    /**
     * Sets avatar shape to circle.
     */
    this.rounded = false;
    /**
     * Sets avatar size to small (32x32).
     */
    this.small = false;
    /**
     * Sets `initials` string characters number (min: 1, max: 3)
     */
    this.initialsSize = 2;
    this.shownInitials = '';
  }
  initialsWatcher() {
    this.shownInitials = this.initials;
    if (this.initials && this.initials.length > this.initialsSize) {
      this.shownInitials = this.initials.slice(0, this.initialsSize);
    }
  }
  initialsSizeWatcher() {
    if (this.initialsSize < 1) {
      this.initialsSize = 1;
    }
    if (this.initialsSize > 3) {
      this.initialsSize = 3;
    }
    this.initialsWatcher();
  }
  showInitials() {
    if (!this.shownInitials || this.image) {
      return false;
    }
    return true;
  }
  componentWillLoad() {
    this.initialsSizeWatcher();
  }
  render() {
    const style = {};
    if (this.image) {
      style['background-image'] = `url(${this.image})`;
    }
    return h(Host, { style: style }, this.showInitials() ? this.shownInitials : '');
  }
  static get is() { return "sy-avatar"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "rounded": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets avatar shape to circle."
      },
      "attribute": "rounded",
      "reflect": true,
      "defaultValue": "false"
    },
    "small": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets avatar size to small (32x32)."
      },
      "attribute": "small",
      "reflect": true,
      "defaultValue": "false"
    },
    "image": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets avatar background-image (URL)."
      },
      "attribute": "image",
      "reflect": false
    },
    "initials": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets a text its shown if there is no `image`.\nMust be a string with same size of `initialsSize`."
      },
      "attribute": "initials",
      "reflect": false
    },
    "initialsSize": {
      "type": "number",
      "mutable": true,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets `initials` string characters number (min: 1, max: 3)"
      },
      "attribute": "initials-size",
      "reflect": true,
      "defaultValue": "2"
    }
  }; }
  static get watchers() { return [{
      "propName": "initials",
      "methodName": "initialsWatcher"
    }, {
      "propName": "initialsSize",
      "methodName": "initialsSizeWatcher"
    }]; }
}
